import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { createHead } from "@vueuse/head";

const app = createApp(App);
const head = createHead();

app.use(store).use(router);

// Access the reCAPTCHA site key from environment variables
const siteKey: string = (process.env.VUE_APP_RECAPTCHA_SITE_KEY ||
  "") as string;

if (!siteKey || siteKey === "") {
  console.error(
    "Missing VUE_APP_RECAPTCHA_SITE_KEY environment variable. Check your .env file."
  );
} else {
  console.log("reCAPTCHA site key loaded successfully");
}

app.use(VueReCaptcha, {
  siteKey,
  loaderOptions: {
    autoHideBadge: true, // Optional: Automatically hides the badge
  },
});
app.use(head);

app.mount("#app");
